import CustomModal from "../CustomModal";

const PasswordVerificationModal = ({
  isOpen,
  onRequestClose,
  title,
  description,
  password,
  onPasswordChange,
  onSubmit,
  buttonText = "Complete",
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="view-staff-modal"
      contentLabel="Password Verification"
    >
      <div>
        <div className="enter-password">
          <h2>Enter Password</h2>
        </div>
        <p>{description}</p>
        <form className="view-staff-form" onSubmit={onSubmit}>
          <label htmlFor="password">Password:</label>
          <br />
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={onPasswordChange}
            required
            autoComplete="new-password"
            autoFill="off"
            data-lpignore="true"
            spellCheck="false"
          />
          <div className="modal-button">
            <button type="button" onClick={onRequestClose}>
              Back
            </button>
            <button type="submit">{buttonText}</button>
          </div>
        </form>
      </div>
    </CustomModal>
  );
};

export default PasswordVerificationModal;
